{
  "INBOX": {
    "LIST": {
      "TITLE": "Moj sandučić",
      "DISPLAY_DROPDOWN": "Prikaz",
      "LOADING": "Dohvaćanje obavijesti",
      "404": "U ovoj grupi nema aktivnih obavijesti.",
      "NO_NOTIFICATIONS": "Nema obavijesti",
      "NOTE": "Obavijesti iz svih pretplaćenih sandučića",
      "NO_MESSAGES_AVAILABLE": "Ups! Nije moguće dohvatiti poruke",
      "SNOOZED_UNTIL": "Odgođeno do",
      "SNOOZED_UNTIL_TOMORROW": "Odgođeno do sutra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odgođeno do sljedećeg tjedna"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Odgodi obavijest",
      "DELETE": "Izbriši obavijest",
      "BACK": "Natrag"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Spomenuti ste u razgovoru",
      "CONVERSATION_CREATION": "Kreiran je novi razgovor",
      "CONVERSATION_ASSIGNMENT": "Dodijeljen vam je razgovor",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova poruka u dodijeljenom razgovoru",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova poruka u razgovoru u kojem sudjelujete",
      "SLA_MISSED_FIRST_RESPONSE": "Propušten SLA cilj za prvi odgovor u razgovoru",
      "SLA_MISSED_NEXT_RESPONSE": "Propušten SLA cilj za sljedeći odgovor u razgovoru",
      "SLA_MISSED_RESOLUTION": "Propušten SLA cilj za rješavanje razgovora"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Spominjanje",
      "CONVERSATION_ASSIGNMENT": "Dodijeljeno vama",
      "CONVERSATION_CREATION": "Novi razgovor",
      "SLA_MISSED_FIRST_RESPONSE": "Kršenje SLA",
      "SLA_MISSED_NEXT_RESPONSE": "Kršenje SLA",
      "SLA_MISSED_RESOLUTION": "Kršenje SLA",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova poruka",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova poruka",
      "SNOOZED_UNTIL": "Odgođeno za {time}",
      "SNOOZED_ENDS": "Odgoda je završila",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova poruka"
    },
    "NO_CONTENT": "Nema dostupnog sadržaja",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Odlazni poziv - povezan",
      "OUTBOUND_FAILED": "Odlazni poziv - neuspješan",
      "INBOUND_MISSED": "Dolazni poziv - propušten",
      "INBOUND_UNANSWERED_MISSED": "Dolazni poziv - propušten neodgovoren",
      "INBOUND_AGENT": "Dolazni poziv - odgovorio agent",
      "INBOUND_IVR": "Dolazni poziv - odgovorio IVR",
      "DEFAULT": "Telefonski poziv"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Označi kao pročitano",
      "MARK_AS_UNREAD": "Označi kao nepročitano",
      "SNOOZE": "Odgodi",
      "DELETE": "Izbriši",
      "MARK_ALL_READ": "Označi sve kao pročitano",
      "DELETE_ALL": "Izbriši sve",
      "DELETE_ALL_READ": "Izbriši sve pročitane"
    },
    "DISPLAY_MENU": {
      "SORT": "Poredaj",
      "DISPLAY": "Prikaz:",
      "SORT_OPTIONS": {
        "NEWEST": "Najnovije",
        "OLDEST": "Najstarije",
        "PRIORITY": "Prioritet"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Odgođene",
        "READ": "Pročitane",
        "LABELS": "Oznake",
        "CONVERSATION_ID": "ID razgovora"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Obavijest je označena kao pročitana",
      "MARK_AS_UNREAD": "Obavijest je označena kao nepročitana",
      "SNOOZE": "Obavijest je odgođena",
      "DELETE": "Obavijest je izbrisana",
      "MARK_ALL_READ": "Sve obavijesti su označene kao pročitane",
      "DELETE_ALL": "Sve obavijesti su izbrisane",
      "DELETE_ALL_READ": "Sve pročitane obavijesti su izbrisane"
    }
  }
}
